import { F as e, K as t, L as n, a as r, g as i, i as a, p as o, t as s, v as c, w as l } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as u } from "./LLMMessage.ce-DuEsMir7.js";
import { t as d } from "./shadow-dom-9FbsLIC0.js";
//#region src/webcomponents/pix-llm/LLMMessages.ce.vue?vue&type=script&setup=true&lang.ts
var f = {
	class: "llm-messages",
	"aria-live": "polite"
}, p = /*#__PURE__*/ s(/* @__PURE__ */ l({
	__name: "LLMMessages.ce",
	props: { messages: { type: Array } },
	setup(a) {
		let s = a;
		d();
		let l = r();
		function p() {
			l.scrollTop = l.scrollHeight;
		}
		return t(async () => {
			s.messages, p();
		}), (t, r) => (e(), c("div", f, [(e(!0), c(o, null, n(a.messages, (t, n) => (e(), i(u, {
			key: n,
			message: t
		}, null, 8, ["message"]))), 128))]));
	}
}), [["styles", ["*{box-sizing:border-box}:host{scroll-behavior:smooth;height:100%;overflow:auto}@media (prefers-reduced-motion:reduce){:host{scroll-behavior:auto}}.llm-messages{flex-direction:column;gap:29px;padding:24px;display:flex}"]]]);
//#endregion
//#region src/webcomponents/pix-llm/llm-messages.ce.js
window.customElements.define("llm-messages", a(p));
//#endregion
